import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {receiptGroupActions} from "./receiptGroupSlice";
import {receiptApi} from "~/api";

function* fetchReceiptGroupList(action) {
	try {
		const response = yield call(receiptApi.groupGets, action.payload);
		yield put(receiptGroupActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch receiptGroup list', error);
		yield put(receiptGroupActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(receiptGroupActions.setFilter(action.payload));
}

export default function* receiptGroupSaga() {
	yield takeLatest(receiptGroupActions.fetchData.type, fetchReceiptGroupList);
	yield debounce(500, receiptGroupActions.setFilterWithDebounce.type, handleSearchDebounce)
}

